
import { UserProfileSection } from "@/components/UserProfileSection";
import { ThemeToggle } from "./ThemeToggle";
import { SidebarToggleButton } from "./SidebarToggleButton";

export function SidebarFooterContent() {
  return (
    <>
      <ThemeToggle />
      <UserProfileSection />
      <SidebarToggleButton />
    </>
  );
}
